export function valueFrom(formData, key) {
    const value = formData.get(key);
    return typeof value === "string" && value.trim() ? value.trim() : undefined;
}
export function numericValueFrom(formData, key) {
    const value = valueFrom(formData, key);
    if (!value) {
        return undefined;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}
export function formatField(value) {
    if (Array.isArray(value)) {
        return value.filter((entry) => typeof entry === "string" || typeof entry === "number").join(" ");
    }
    if (value === false || value === null || value === undefined) {
        return "";
    }
    return String(value);
}
export function labelFromKey(key) {
    return key.replace(/_/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}
export function hasManyToManyValues(value) {
    return Array.isArray(value) && value.length > 0;
}
export function formatEuroAmount(value) {
    const amount = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(amount)) {
        return formatField(value);
    }
    return new Intl.NumberFormat("de-DE", {
        currency: "EUR",
        style: "currency"
    }).format(amount);
}
export function formatOdooDate(value) {
    const formattedValue = formatField(value);
    if (!formattedValue) {
        return "";
    }
    const [datePart] = formattedValue.split(" ");
    const [year, month, day] = datePart.split("-");
    if (!year || !month || !day) {
        return formattedValue;
    }
    return `${day}.${month}.${year}`;
}
export function getTelUrl(value) {
    const normalized = value.replace(/[^\d+]/g, "");
    return `tel:${normalized}`;
}
export function getWebsiteUrl(value) {
    return /^https?:\/\//i.test(value) ? value : `https://${value}`;
}
